import { Card } from "antd"
import Chart from "react-apexcharts"
import { Purify } from "@shared/components"
import React from "react"

interface IFProps {
	labels?: string[]
	count?: number[]
	loading?: boolean
}
const StatisticsChart: React.FC<IFProps> = ({ labels, count, loading }) => {
	return (
		<Card title="Statistics" style={{ minHeight: 300 }}>
			<Purify
				loading={loading}
				empty={count?.reduce((acc: any, curr: any) => acc + curr, 0) === 0}>
				<div style={{ justifyContent: "center", display: "flex" }}>
					<Chart
						options={
							{
								chart: {
									width: 280,
									height: 280,
									type: "pie",
									labels: {
										itemMargin: {
											horizontal: 5,
											vertical: 0,
										},
									},
								},
								legend: {
									position: "bottom",
								},
								labels: labels,

								colors: ["#6AC5F6", "#7366FF"],
							} as any
						}
						series={count}
						type="pie"
						width={300}
					/>
				</div>
			</Purify>
		</Card>
	)
}
export default StatisticsChart
